/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Cancel_Body_SetsInputs */

const en_us2_workout_after_cancel_body_sets = /** @type {(inputs: Workout_After_Cancel_Body_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sets already logged stay in your history.`)
};

const pt_br2_workout_after_cancel_body_sets = /** @type {(inputs: Workout_After_Cancel_Body_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As séries já registradas ficam no seu histórico.`)
};

const es_419_workout_after_cancel_body_sets = /** @type {(inputs: Workout_After_Cancel_Body_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las series ya registradas quedan en tu historial.`)
};

const pt_pt2_workout_after_cancel_body_sets = /** @type {(inputs: Workout_After_Cancel_Body_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As séries já registadas ficam no teu histórico.`)
};

const fr_fr2_workout_after_cancel_body_sets = /** @type {(inputs: Workout_After_Cancel_Body_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les séries déjà enregistrées restent dans ton historique.`)
};

const de_de2_workout_after_cancel_body_sets = /** @type {(inputs: Workout_After_Cancel_Body_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die bereits erfassten Sätze bleiben in deinem Verlauf.`)
};

const it_it2_workout_after_cancel_body_sets = /** @type {(inputs: Workout_After_Cancel_Body_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le serie già registrate restano nel tuo storico.`)
};

/**
* | output |
* | --- |
* | "The sets already logged stay in your history." |
*
* @param {Workout_After_Cancel_Body_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_cancel_body_sets = /** @type {((inputs?: Workout_After_Cancel_Body_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Cancel_Body_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_cancel_body_sets(inputs)
	if (locale === "es-419") return es_419_workout_after_cancel_body_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_cancel_body_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_cancel_body_sets(inputs)
	if (locale === "de-DE") return de_de2_workout_after_cancel_body_sets(inputs)
	if (locale === "it-IT") return it_it2_workout_after_cancel_body_sets(inputs)
	return en_us2_workout_after_cancel_body_sets(inputs)
});
export { workout_after_cancel_body_sets as "workout-after.cancel_body_sets" }